"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyPolicyHero() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2777" id="privacy-policy-hero" className="bg-background text-foreground relative min-h-[85vh] w-full overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        <div ref={labelRef} className={`mb-12 md:mb-20 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default text-xs md:text-sm uppercase tracking-[0.18em]" style={{
          color: "var(--chart-5)"
        }}>
            § legal — privacy policy
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 relative">
          <div aria-hidden="true" className="hidden lg:block absolute top-0 bottom-0 left-[58.33%] w-px" style={{
          background: "var(--border)"
        }} />

          <div className="lg:col-span-7 flex flex-col justify-center">
            <h1 ref={headlineRef} className={`font-default font-light leading-[0.92] tracking-tight text-foreground transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            fontSize: "clamp(56px, 12vw, 176px)"
          }}>
              Privacy Policy
            </h1>

            <div ref={introRef}>
              <p className={`font-default italic mt-10 md:mt-14 max-w-[36ch] text-base md:text-lg leading-relaxed transition-all duration-1000 delay-300 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              color: "var(--chart-4)"
            }}>
                At Blue Phoenix Ventures, we recognize that the confidentiality of your financial data and business legacy is paramount. This policy outlines our rigorous standards for data protection and transparency.
              </p>
              <p className={`font-mono mt-6 text-[10px] md:text-xs uppercase tracking-widest transition-all duration-1000 delay-500 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              color: "var(--chart-3)"
            }}>
                Effective Date: October 24, 2023
              </p>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col justify-center gap-8 lg:gap-10 lg:pl-6">
            <figure ref={image1Ref} className={`transition-all duration-1000 ease-out ${image1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-lg bg-card shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/legal_compliance_shield.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/legal_compliance_shield.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/legal_compliance_shield.webp-wvc-sizes" alt="Abstract representation of data security and legal compliance" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5]" />
              </div>
              <figcaption className="mt-3 font-default text-[11px] md:text-xs uppercase tracking-[0.16em]" style={{
              color: "var(--chart-5)"
            }}>
                section i. / data protection
              </figcaption>
            </figure>

            <figure ref={image2Ref} className={`ml-auto w-[72%] transition-all duration-1000 delay-200 ease-out ${image2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-lg bg-card shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/privacy_document_detail.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/privacy_document_detail.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/privacy_document_detail.png-wvc-sizes" alt="Detail shot of formal privacy documentation" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-square" />
              </div>
              <figcaption className="mt-3 font-default text-[11px] md:text-xs uppercase tracking-[0.16em]" style={{
              color: "var(--chart-5)"
            }}>
                section ii. / privacy standards
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}